<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('routes.executionResult')"
    :visible.sync="resultDialog"
    width="550px"
  >
    <div style="display: flex; margin: 20px 0">
      <!--总导入数据-->
      <div style="flex: 1">{{ $t('routes.totalImportedData') }}: {{ resultData.totalCount }}</div>
      <!--导入成功-->
      <div style="flex: 1">
        {{ $t('orderCenterCont.ImportWasSuccessful') }}: {{ resultData.successCount }}
      </div>
      <!--导入失败-->
      <div style="flex: 1">
        {{ $t('orderCenterCont.ImportFailed') }}: {{ resultData.failureCount }}
      </div>
    </div>
    <el-button
      v-if="resultData.failureCount"
      size="small"
      type="primary"
      @click="toResourceTaskList"
    >{{ $t('routes.downloadFailedData') }}
    </el-button>
    <div slot="footer" class="dialog-footer">
      <el-button
        size="small" @click="resultDialog = false"
      >{{ $t('GlobalSetObj.cancel') }}
      </el-button>
      <el-button
        size="small" type="primary" @click="resultDialog = false"
      >{{ $t('GlobalSetObj.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
// 校验函数：确保输入为数字

// 校验函数：确保输入为数字
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  data() {
    return {
      resultData: {
        totalCount: 0,
        successCount: 0,
        failureCount: 0
      },
      resultDialog: false
    };
  },
  methods: {
    // 控制弹框
    openResultDialog(arg) {
      console.log(arg, 'openResultDialog');
      if (arg) {
        this.resultData = arg;
        this.resultDialog = true;
      }
    },
    toResourceTaskList() {
      this.resultDialog = false;
      goResourceTaskList();
    }
  }
};
</script>

<style scoped></style>
